import React, { Fragment, Component } from "react";
import _ from 'lodash';
import styled from 'styled-components';
import { compose } from "redux";
import { connect } from "react-redux";
import {
    TextField,
  } from "@material-ui/core";
import MaterialDatePicker from "material-ui-pickers/DatePicker";
import { DEAL_KEY } from "store/state/fund";
import numberFormatter from 'utils/numberFormatter';
import {
  TwoDecimalPercentFormat,
  DollarAndCentFormat,
  FloatFormat,
} from 'components/Notifications/FormattedInputs';
import  {seniorityMap} from  "constants/loanSeniorityTypes";
import loanStatuses from "constants/loanStatuses";

const StyledTextField = styled(TextField)`
  max-width:130px;
`;

  const seniority = seniorityMap;

  const CLOSED_LOAN = loanStatuses.CLOSED_LOAN;

  const ContainerDiv = styled.div`
    width: 100%;
    min-height: 100px;
  `;
  
  const GrayP = styled.p`
    color: #777777;
  `;

  const PayoffTable = styled.table`
    width: 100%
    padding-left: 20px;
  `;


  export class PayoffComponent extends Component {
    state = {
      loanDates : {

      },
      loanBalances : {

      },
      loanPrepayments : {

      }
    }

    componentWillUnmount() {
      this.props.deal.loans.forEach(loan => {
        if(loan.loanStatusId === CLOSED_LOAN){
        this.props.setLoanProperty(loan.id, "balance" , 
            this.state.loanBalances[loan.id] || this.props.loanInfo[loan.id] && this.props.loanInfo[loan.id].balance ? this.props.loanInfo[loan.id].balance : loan.currentPrincipalBalance || 0);
       this.props.setLoanProperty(loan.id, "prepaymentPenalty" , 
            this.state.loanPrepayments[loan.id] || this.props.loanInfo[loan.id] && this.props.loanInfo[loan.id].prepaymentPenalty ? this.props.loanInfo[loan.id].prepaymentPenalty : loan.prepaymentPenalty || 0);
        }
     });
    }

    renderPayoffTable = (deal) => {
      if(!deal) return null;
      const rows = [];
      rows.push(
        <tr style={{fontWeight: "bold", textAlign: "center"}}>
          <td style={{width: "50%"}}>
          </td>
          <td style={{width: "17%"}}>
            Balance
          </td>
          <td style={{width: "17%", whiteSpace: "nowrap"}}>
            Prepayment Penalty
          </td>
          <td style={{width: "17%"}}>
            Paid Off Date
          </td>
        </tr>
      );

      deal.loans.forEach(loan =>{
        if(loan.loanStatusId === CLOSED_LOAN){
          rows.push(
            <tr>
              <td style={{width: "50%", fontWeight: "bold", fontSize: "13pt"}}>
                {`${loan.loanProvider[0] ? loan.loanProvider[0].name : "No Loan Provider"} - ${seniority[loan.loanSeniorityId]} ${loan.closingDate ? `- ${formatISO(loan.closingDate)}` : ``}`}
              </td>
              <td style={{width:"17%", textAlign: "center"}}>
                {renderInput({
                  type: "money",
                  value : this.state.loanBalances[loan.id] || this.props.loanInfo[loan.id] && this.props.loanInfo[loan.id].balance ? this.props.loanInfo[loan.id].balance : loan.currentPrincipalBalance || 0,
                  onBlur: (event)=>{
                        this.props.setLoanProperty(loan.id, "balance" , event.target.value.substring(1).replace(/,/g, "")); //substring to get rid of $
                        let newBalances = this.state.loanBalances;
                        newBalances[loan.id] = event.target.value.substring(1).replace(/,/g, "");
                        this.setState({loanBalances: newBalances});
                      }
                })}
              </td>
              <td style={{width:"17%", textAlign: "center"}}>
              {renderInput({
                  type: "money",
                  defaultValue: loan.prepaymentPenalty,
                  value : this.state.loanPrepayments[loan.id] || this.props.loanInfo[loan.id] && this.props.loanInfo[loan.id].prepaymentPenalty ? this.props.loanInfo[loan.id].prepaymentPenalty : loan.prepaymentPenalty || 0,
                  onBlur: (event)=>{
                    this.props.setLoanProperty(loan.id, "prepaymentPenalty" , event.target.value.substring(1).replace(/,/g, "")); //substring to get rid of $
                    let newPrepayments = this.state.loanPrepayments;
                    newPrepayments[loan.id] = event.target.value.substring(1).replace(/,/g, "");
                    this.setState({loanPrepayments: newPrepayments});
                  }
                })}
              </td>
              <td style={{width:"17%", textAlign: "center"}}>
              <MaterialDatePicker
                format = "MM/DD/YYYY"
                placeholder = "MM/DD/YYYY"
                value = {this.state.loanDates[loan.id] || this.props.loanInfo[loan.id] && this.props.loanInfo[loan.id].paidOffDate ? this.props.loanInfo[loan.id].paidOffDate : null}
                style = {{marginLeft: "20px", width: "75%"}}
                onChange = { event => {
                    let newDatesObject = this.state.loanDates;
                    newDatesObject[loan.id] = event;
                    this.setState({loanDates: newDatesObject});
                    this.props.setLoanProperty(loan.id, "paidOffDate", event);
                }}
              />
              </td>
            </tr>
          );
        }
      });

      return (
        <PayoffTable>
            {rows}
        </PayoffTable>
      )
    }

    render() {
      const { deal } = this.props;
      return (
        <ContainerDiv>
          <GrayP>
            Please enter the pay off information for the following active loans:
          </GrayP>
          {this.renderPayoffTable(deal)}
          <GrayP style={{marginTop:"40px"}}>
            NOTE: If the information above is not available at this time, you will need to enter this data on each individual loan at a later date.
          </GrayP>
        </ContainerDiv>
      )
    }
    
  }

  const renderInput = ({type, defaultValue, onChange, onBlur, style, internalLabel, value}) => {
    let inputProps = {
    style:{
        textAlign: "center", 
        transition: '0.3s',
        }
    };
    switch(type){
        case 'money':
            inputProps.inputComponent = DollarAndCentFormat;
            break;   
        case 'percent':
            inputProps.inputComponent = TwoDecimalPercentFormat;
            break;
        case 'integer':
            inputProps.inputComponent = FloatFormat;
        default:
            break;
    }
    return (
        <StyledTextField 
            defaultValue = {defaultValue}
            InputProps = {inputProps}
            onChange = {onChange}
            onBlur = {onBlur}
            label = {internalLabel}
            style={style}
            value = {value}
        />
    )
}

const formatISO = (iso) => {
  if(typeof(iso) === "string"){
    let components = iso.split("-");
    return `${components[1]}/${components[2]}/${components[0]}`;
  }else{
    return `${iso.getMonth()}/${iso.getDay()}/${iso.getFullYear()}`
  } 
}

function mapStateToProps({ deal }) {
  return {
      deal: deal.closeRefiModelInfo,
  };
}

export default compose(
connect(
  mapStateToProps,
  {
    
  }
)
)(PayoffComponent);